import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconModeLightStyle0 = cosmosIconCss;

const CosmosIconModeLight$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconModeLight extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '0dd53066c32e3f22a87071001d97cf81a00c4b5c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'd4cb36309ffd5bfa8bd198cd90a7ec44045debd8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'fba4602e887257933bb0c1ff2cd9a764471dcece', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.25 2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h.5Zm6.291 2.813a.5.5 0 0 1 0 .707l-1.414 1.414a.5.5 0 0 1-.707 0l-.354-.353a.5.5 0 0 1 0-.707l1.414-1.415a.5.5 0 0 1 .707 0l.354.354ZM19.5 11.75a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h2Zm-4.08 3.316a.5.5 0 0 1 .707 0l1.414 1.414a.5.5 0 0 1 0 .707l-.353.354a.5.5 0 0 1-.707 0l-1.415-1.414a.5.5 0 0 1 0-.707l.354-.354ZM11.75 17.5a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-2Zm-4.814-2.08a.5.5 0 0 1 0 .707L5.52 17.54a.5.5 0 0 1-.707 0l-.353-.354a.5.5 0 0 1 0-.707l1.414-1.414a.5.5 0 0 1 .707 0l.354.353ZM4.5 11.75a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h2Zm.313-7.29a.5.5 0 0 1 .707 0l1.414 1.413a.5.5 0 0 1 0 .708l-.354.353a.5.5 0 0 1-.707 0L4.46 5.52a.5.5 0 0 1 0-.707l.354-.354ZM6.5 11a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0Zm7.5 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconModeLightStyle0; }
}, [1, "cosmos-icon-mode-light", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-mode-light"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-mode-light":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconModeLight$1);
            }
            break;
    } });
}

const CosmosIconModeLight = CosmosIconModeLight$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconModeLight, defineCustomElement };
